<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md6>
        <CardHeader />
        <div class="card-container">
          <slot />
        </div>
        <slot name="subcontent" />
        <CardFooter />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CardFooter from './CardFooter.vue';
import CardHeader from './CardHeader.vue';

export default {
  components: {
    CardFooter,
    CardHeader,
  },
  inject: ['$validator'],
  data() {
    return {
      $validator: this.$validator || {},
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/theme';

.card-container {
  background: $theme-color-white;
  border: 2px #D3D3D3 solid;
  border-radius: 5px;
  box-shadow: 0 10px 50px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
}
</style>
